import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  KnowledgeBaseType,
  EmbeddingModelARN,
  EmbeddingDimensions,
  EmbeddingDataType,
  IAMRoleARN,
  KnowledgeBaseMongoDBCredentialsSecretARN,
  KnowledgeBasePineconeCredentialsSecretARN,
  KnowledgeBaseRDSClusterARN,
  KnowledgeBaseRedisCredentialsSecretARN,
  KnowledgeBaseStorageType,
  UpdatedAt,
  VectorBucketARN,
  VectorIndexARN,
  VectorIndexName,
} from '../../../../Components/MetadataField/MetaGridFields';

export const AWSBedrockKnowledgeBaseMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;
  const metadata = { ...resource, ...insight };

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields
        state={metadata}
        availabilityZone="None"
        vpc="None"
        owner="None"
        createdAt={metadata}
      />
      {UpdatedAt(metadata)}
      {KnowledgeBaseType(metadata)}
      {EmbeddingModelARN(metadata)}
      {EmbeddingDimensions(metadata)}
      {EmbeddingDataType(metadata)}
      {KnowledgeBaseStorageType(metadata)}
      {VectorBucketARN(metadata)}
      {VectorIndexName(metadata)}
      {VectorIndexARN(metadata)}
      {KnowledgeBaseRDSClusterARN(metadata)}
      {KnowledgeBasePineconeCredentialsSecretARN(metadata)}
      {KnowledgeBaseRedisCredentialsSecretARN(metadata)}
      {KnowledgeBaseMongoDBCredentialsSecretARN(metadata)}
      {IAMRoleARN(metadata)}
    </Grid>
  );
};
